import { Modal } from '@/components/Elements';
import { Button } from '@/components/TSX components';

export const RouterKeyDefPauseModal = ({
  isOpen,
  handleProceed,
  handleStay,
  // handleLeave,
  setSavingKD,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={handleStay}
      title={'Leave Page?'}
      headerClassName="pt-4 px-3"
      titleClassName="text-sm leading-5 text-brand-ai-200"
      topStripClassName="hidden"
      topBorderClassname={`border-t-5 border-pv-warning-warning-text`}
      className="max-w-xl w-120 relative"
      closeClassName="right-3 top-4"
    >
      <div className="flex flex-col gap-4 justify-between">
        <div className="p-3 pb-0 flex flex-col gap-2">
          <span className="text-xs text-pv-text-primary-text">
            Your changes will not be saved.
          </span>
          <span className="font-medium text-pv-text-primary-text">
            Are you sure you want to leave this page?
          </span>
        </div>
        <div className="border-t-2 mt-2 w-full flex justify-between px-3 py-4">
          <Button
            btnColor="ghost"
            onClick={() => {
              handleStay();
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={async () => {
              // await handleLeave();
              setSavingKD(false);
              setTimeout(() => handleProceed(), 0);
            }}
          >
            Leave
          </Button>
        </div>
      </div>
    </Modal>
  );
};
